import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { GridAreaContainer } from "./styles";
export var GridArea = forwardRef(function (_a, ref) {
    var areaTemplate = _a.areaTemplate, _b = _a.gap, gap = _b === void 0 ? "8px" : _b, children = _a.children, props = __rest(_a, ["areaTemplate", "gap", "children"]);
    var colCount = areaTemplate[0].reduce(function (acc, cur) {
        return acc + Math.abs(cur);
    }, 0);
    var start = 0;
    return (_jsxs(GridAreaContainer, __assign({ ref: ref, colCount: colCount, gap: gap }, props, { children: [areaTemplate.map(function (row) {
                var elementsCount = row.length;
                var positiveCount = row.filter(function (el) { return el > 0; }).length;
                var elementsToReturn = children
                    .slice(start, start + elementsCount)
                    .map(function (child, idx) {
                    if (row[idx] < 0) {
                        return (_jsx("div", { style: { gridColumn: "span ".concat(Math.abs(row[idx])) } }));
                    }
                    return React.cloneElement(child, {
                        style: __assign(__assign({}, child.props.style), { gridColumn: "span ".concat(row[idx]) }),
                    });
                });
                start += positiveCount;
                return elementsToReturn;
            }), children.slice(start + 1).map(function (child) {
                return child;
            })] })));
});
//# sourceMappingURL=index.js.map